<template>
  <div>
    <div class="w-app">
      <div id="application-wrapper">

        <TopBarDesktop/>
        
        <!-- <div class="desktopPopup">
          <modal name="welcome-message-modal"
                :adaptive="true"
                @closed="closedWelcomeModal">
            <div class="welcome-modal-main">
              <a href="https://darklands.be" target="_blank" class="inner">
                <div class="close"
                  @click.prevent="hideModal">
                </div>
                <img src="/assets/img/Buddy_Popup_Darklands.jpg">
              </a>
            </div>
          </modal>
        </div> -->

        <vue-custom-scrollbar class="content-wrapper" id="js-discover-content" ref="discoverScrollContent" v-on:scroll="prepareScroll($event.target)">
          <div @mouseover="stopOnlineFavoriteRefresh = true" @mouseout="stopOnlineFavoriteRefresh = false"  class="favorites" v-on:mouseover="buttonControl(true)" v-on:mouseleave="buttonControl(false)" v-if="(!meetNowStatus || !meetNowUsers || !meetNowUsers.length) && showFavoriteOnline && profile.id">
            <div class="h1">{{ trans('favorites_online') }}</div>
            <div id="favorites" class="faces-container" style="display: flex; align-items: center">
              <vue-horizontal  snap="none" :button="showHorizontalButtons" @prev="onBack" @next="onNext" ref="faces" class="faces">
                <div class="face" :key="index" v-for="(favorite, index) in favoritesOnline"
                     :dusk="'favorite-online-'+favorite.id" href="javascript:void(0)"
                     @click="openUserModal(favorite.id, 1)"
                     :class="{'meet_now': favorite.meet_now,'online': favorite.isOnline, 'was-online': favorite.wasRecentlyOnline && !favorite.isOnline, 'default-photo': favorite.photo_small === '/assets/img/default_180x180.jpg', 'sensitive': favorite.photo_small === '/assets/img/toohot_180x180.jpg'}">
                  <div class="img" :style="{'background': `url(${favorite.photo_small}) no-repeat center / cover`}"></div>
                  <div class="details">
                    <div class="name notranslate">{{ favorite.headline }}</div>
                  </div>
                </div>

                <infinite-loading
                    ref="infiniteLoadingFavorites"
                    @infinite="loadOnlineUsers"
                    :distance="800"
                    force-use-infinite-wrapper=".v-hl-container"
                    direction="right"
                    spinner="bubbles">
                  <span slot="no-more"></span>
                  <span slot="no-more"></span>
                  <span slot="no-results"></span>
                </infinite-loading>
              </vue-horizontal>
            </div>

          </div>
          <div v-if="meetNowStatus && meetNowUsers && meetNowUsers.length" class="favorites" id="meet_more_users">
            <MeetNowSidebar></MeetNowSidebar>
          </div>

            <DiscoverTabs></DiscoverTabs>
            <div class="pagetitle">
<!--              <h1>{{ trans(filterBuddies) }}</h1>-->
            </div>
            <div class="faces catalog" :class="{'list': viewType === 'list'}">

              <div class="face" :id="'discover-user-' + user.id" v-for="user in usersAround"
                   @click="openUserModal(user.id, 2)"
                   data-open2="card"
                   :class="{'meet_now': user.meet_now,'online': user.isOnline || (user.meet_now && user.id === profile.id), 'was-online': user.wasRecentlyOnline && !user.isOnline, 'favorite': user.isFavorite, 'sensitive': user.photo_small === '/assets/img/toohot_180x180.jpg', 'default-photo': user.photo_small == '/assets/img/default_180x180.jpg'}">
                <div class="img" :style="{'background': `url(${user.photo_small}) no-repeat center / cover`}"></div>
                <div class="has-videos" v-if="user.has_videos"></div>
                <div class="number-indicator" v-if="user.unreadMessagesCount">{{ user.unreadMessagesCount }}</div>
                <div class="details">
                  <div class="name notranslate">{{ user.headline }}</div>
                  <div class="parameters-box">
                    <div class="parameters">
                      <span v-if="user.age">{{ user.age }}</span>
                      <span v-if="user.height">{{ formatHeight(user.height, false) }}</span>
                      <span v-if="user.weight">{{ formatWeight(user.weight, false) }}</span>
                      <span v-if="user.position">{{ transPosition(user.position, true) }}</span>
                    </div>
                    <div class="distance" v-if="user.id != authUserId">{{ getDistanceString(user, false) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <infinite-loading
                ref="infiniteLoadingDiscover"
                @infinite="loadUsersAround"
                :distance="1500"
                force-use-infinite-wrapper="#js-discover-content"
                spinner="bubbles">
              <span slot="no-more">{{ trans(profile.id ? 'no_more_users_around' : 'to_see_members_become_a_member') }}</span>
              <span slot="no-more"></span>
              <span slot="no-results">{{ trans(profile.id ? 'no_more_users_around' : 'to_see_members_become_a_member') }}</span>
            </infinite-loading>
            <transition name="fade">
              <div v-show="showScrollTop" class="scroll_top-button"
                   @click="scrollToTop()" :title="trans('arrow_scroll_top')">
                <svg class="icon icon-arrow_up">
                  <use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_up')"></use>
                </svg>
              </div>
            </transition>
        </vue-custom-scrollbar>

        <HideChats />
      </div><!--#application-wrapper-->
    </div><!--w-app-->
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
InfiniteLoading.methods.getCurrentDistance = function (){
  let distance;

  if (this.direction === 'top') {
    distance = typeof this.scrollParent.scrollTop === 'number'
        ? this.scrollParent.scrollTop
        : this.scrollParent.pageYOffset;
  } else if(this.direction === 'bottom') {
    const infiniteElmOffsetTopFromBottom = this.$el.getBoundingClientRect().top;
    const scrollElmOffsetTopFromBottom = this.scrollParent === window
        ? window.innerHeight
        : this.scrollParent.getBoundingClientRect().bottom;

    distance = infiniteElmOffsetTopFromBottom - scrollElmOffsetTopFromBottom;
  } else if(this.direction === 'right') {
    const infiniteElmOffsetLeftFromRight = this.$el.getBoundingClientRect().left;
    const scrollElmOffsetLeftFromRight = this.scrollParent === window
        ? window.innerWidth
        : this.scrollParent.getBoundingClientRect().right;

    distance = infiniteElmOffsetLeftFromRight - scrollElmOffsetLeftFromRight;
  }

  return distance;

};
import TopBarDesktop from '@buddy/views/widgets/TopBarDesktop.vue';
import DiscoverDesktopFilterReveals from '@discover/views/widgets/DiscoverDesktopFilterReveals.vue';

import discoverModule from '@discover/module/store/type';

import HideChats from "@buddy/views/widgets/HideChats.vue";

// custom scrollbar
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"

// Vue horizontal for favorites block
import VueHorizontal from 'vue-horizontal';
import MeetNowSidebar from "../widgets/MeetNowSidebar.vue";
import DiscoverTabs from "../widgets/DiscoverTabs.vue";

export default {
  data() {
    return {
      interval: false,
      visibleFilter: false,
      stopOnlineFavoriteRefresh: false,
      showScrollTop: false,
      showAgeConfirmModal: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false
      },
      favoritesSettings: {
          showPrevButton: false,
          showNextButton: false,
          scrollLeftCount: 1000
      },
      favoritesPage: 0,
      windowWidth: window.innerWidth,
      showHorizontalButtons: false,
    }
  },
  mixins: [
    require('@general/lib/mixin').default,
    require('@general/lib/mixin-discover').default
  ],
  components: {
    DiscoverTabs,
    MeetNowSidebar,
    InfiniteLoading,
    TopBarDesktop,
    DiscoverDesktopFilterReveals,
    HideChats,
    vueCustomScrollbar,
    VueHorizontal,
  },
  computed: {
    ...mapState({
      favoritesOnline: state => state.discoverModule.favoritesOnline,
      showFavoriteOnline: state => state.discoverModule.showFavoriteOnline,
      user: 'profile',
    }),
    ...mapGetters({
      'userProfile' :'userProfile',
      'meetNowStatus': 'meetNowStatus',
      'meetNowUsers' : 'meetNowUsers',
    }),
  },
  methods: {
    ...mapActions([
      'trySwitchDiscreetMode',
      'openProfileEdit'
    ]),
    showPartiesOn(slot) {
      if (slot) {
        this.showModal();
      }
    },
    closedWelcomeModal() {
      this.updateUserModalShown({
        'is_guide_modal_shown': true,
      });
    },
    async updateUserModalShown(payload) {
      this.$store.commit('updateUser', payload)
      await axios.post('/api/updateUser', payload)
      console.log(`[User] Modal settings setting updated`, { payload })
    },
    showModal () {
      this.$modal.show('welcome-message-modal');
    },
    hideModal () {
      this.$modal.hide('welcome-message-modal');
    },
    buttonControl(show) {
        this.showHorizontalButtons = show
    },
    onNext() {
        this.favoritesPage += 1
    },
    onBack() {
      this.favoritesPage -= 1
    },
    scrollTo(element, scrollPixels) {
        element.scroll({
          left: scrollPixels,
          top: 0,
          // behavior: 'smooth' DO NOT UNCOMMENT ! IT'S NOT WORKING ON FIREFOX.
        })

        if (this.favoritesPage > 0) {
          this.favoritesSettings.showPrevButton = true;
        } else if (this.favoritesPage === 0) {
          this.favoritesSettings.showPrevButton = false;
        }

        if (element.scrollWidth <= (element.offsetWidth + scrollPixels)) {
            this.favoritesSettings.showNextButton = false;
        } else {
            this.favoritesSettings.showNextButton = true
        }

    },
    checkProFilters() {
      if (!this.userIsPro) {
        const proFilters = this.$store.getters[discoverModule.getters.filter.proFilters];

        proFilters.forEach((value) => {
          let key = `${value}Values`;

          this.$store.dispatch(discoverModule.actions.filter.remove, {
            key,
            refresh: true
          });
        })
      }
    },
    scrollToTop() {
      let container = document.getElementById('js-discover-content');
      container.scrollTo({
        top: 0,
      })
    },
    resetSearchUsers() {
      this.searchInput = ''
      this.$store.dispatch(discoverModule.actions.filter.set, {
        key: 'filterName',
        value: '',
        queueRefresh: true
      })
    },
    setScrollPosition() {
      app.prevUsersAroundPosition = this.$refs.discoverScrollContent.scrollTop
    },
    setfFlterType(value) {
      this.$store.dispatch(discoverModule.actions.filter.set, {
        key: 'filterType',
        value,
        refresh: true
      })
    },
    setScrollToDiscover() {
      let container = document.getElementById('application-wrapper');
      if (container) {
        container.addEventListener('scroll', this.checkScrollDebounce, true);
      }
    },
    prepareScroll(eventTarget) {
      let currentScroll = eventTarget.scrollTop;
      this.handleDiscoverScroll({})
      if (currentScroll === 0) {
        $('#application-wrapper').unbind('touchmove')
        setTimeout(() => {
          let container = $('#application-wrapper')
          container.removeClass('disable-scroll');
        }, 100);
      }

      if (app.isDesktop) {
        this.showScrollTop = currentScroll >= 370;

      }
    },
    checkScrollDebounce: _.debounce(function (event) {
      if (event) {
        let currentScroll = event.target.scrollTop;
        // let scrollHeight = event.target.scrollHeight;
        // let clientHeight = event.target.clientHeight;

        this.scroll = currentScroll

        if (currentScroll > 5) {
          if (this.pullToRefreshInstance) {
            this.pullToRefreshInstance.destroy()
          }
        } else {
          this.pullToRefreshInstance = this.attachPullToRefresh('#js-events-content')
        }

        // if (currentScroll + clientHeight === scrollHeight && this.usersNextPageCount) {
        //   this.$refs.infiniteLoadingDiscover.stateChanger.reset();
        // }

        this.showScrollTop = currentScroll >= 370;
      }
    }, 100),
    checkWidth() {
        const element = this.$refs.faces;
        const container = document.querySelector('.faces-container')

        if (element && container) {
          if (element.scrollWidth - (container.offsetWidth + element.scrollLeft)) {
            this.favoritesSettings.showNextButton = true;
          } else {
            this.favoritesSettings.showNextButton = false;
          }

          if (element.scrollLeft > 0) {
            this.favoritesSettings.showPrevButton = true;
          } else {
            this.favoritesSettings.showPrevButton = false;
          }
        }
    },
    onResize() {
        this.windowWidth = window.innerWidth
    }
  },
  created() {
    console.log('[Discover] Created')
    if (app.isDesktop) {
      this.setScrollToDiscover();
    }
    // app.$on('reload-discover', this.resetUsersAround);
    app.$on('show-parties-on', this.showPartiesOn);
  },
  mounted() {
    let self = this;
    this.checkAgeConfirmModal(function (){
      self.resetUsersAround(true);
    });
    console.log('[Discover] Mounted')
    let v = this
    if(this.$route.query.show_edit_profile){
      this.$store.dispatch('updateSidebarVisibility', {index: 'profile', value:true})
      this.openProfileEdit();
    }
    /*$(document).ready(function() {
        $('#online__favorites').scrollToFixed({
            bottom: 0
        });
    });*/

    this.loadScrollTopButton();

    if (app.isDesktop) {
      this.setScrollToDiscover();
    }

    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })

    const discoverScrollContent = document.getElementById('js-discover-content')

    if (typeof discoverScrollContent !== 'undefined') {
      discoverScrollContent.addEventListener('scroll', function () {
        v.setScrollPosition();
      });
    }

    if (this.$route.query.user) {
      this.openUserModal(this.$route.query.user, 4)
    }

    this.$store.dispatch('showAdminPopUp','radar')
  },
  watch: {
      userIsPro() {
         this.checkProFilters();
         this.resetUsersAround();
      },
      windowWidth() {
          this.checkWidth()
      },
      favoritesOnline() {
          this.checkWidth()
      },
  },
  activated() {
    console.log('[Discover] Activated')
    if (app.isDesktop) {
      this.setScrollToDiscover();
    }

    if (this.$route.meta.back.match(/\/search/)) {
      this.resetUsersAround();
    }

    if (!this.userProfile.is_guide_modal_shown) {
      app.$emit('show-parties-on', true)
    }

    // app.$emit('reload-discover')
    app.$on('reload-discover', this.resetUsersAround)
    let self = this;
    this.interval = setInterval(async function (){
      if(self.stopOnlineFavoriteRefresh || !self.profile.id){
        return ;
      }
      self.$store.commit(discoverModule.mutations.setFavoritesOnlinePage, 0)
      if(!self.showFavoriteOnline){
        await self.loadOnlineUsers(null);
        if(!self.favoritesOnline.length){
          return false;
        }
      }
      self.$store.commit(discoverModule.mutations.showFavoriteOnline.set, true)
      self.$store.commit(discoverModule.mutations.favoritesOnline.reset)
      self.$refs.infiniteLoadingFavorites.stateChanger.reset();
    },60000)
  },
  deactivated() {
    const visibleFilter = this.visibleFilter;
    this.$store.dispatch('updateSidebarVisibility', {index: 'filter', visibleFilter})
    this.closeUserModal();
    clearInterval(this.interval)
  },
  destroyed() {
    const visibleFilter = this.visibleFilter;
    this.$store.dispatch('updateSidebarVisibility', {index: 'filter', visibleFilter})
    app.$off('reload-discover')
    app.$off('show-parties-on')
  }
}
</script>

<style lang="scss">
  .ps__rail-y {
    z-index: 1015 !important;
  }

  .v-hl-btn-next {
    transform: translateX(10%) !important;
  }

  .v-hl-btn-prev {
    transform: translateX(-10%) !important;
  }

  .desktopPopup .vm--modal {
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0;
    box-shadow: none;
  }

  .desktopPopup .welcome-modal-main {
    top: 130px;
  }
</style>